import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar-screen',
    templateUrl: './sidebar-screen.component.html',
    styleUrls: ['./sidebar-screen.component.scss'],
    standalone: false
})
export class SidebarScreenComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit() {
  }

  back(){
    this.router.navigate(['/resume-screen'])
  }

}
